module.exports = "pegasus/assets/loading-icon.gif";